module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Regular-Italic.d59667f6.svg";